
const SPA_DOMAINS = {
  live: 'https://web.tracklify.com',
  dev: 'https://web.devtracklify.com',
  local: 'http://web.tracklify.localhost:8080',
};

const SPA_DEBUG_DOMAINS = {
  live: 'https://debugweb.tracklify.com',
  dev: 'https://debugweb.devtracklify.com',
  local: 'http://debugweb.tracklify.localhost:8080',
};

const SSR_DOMAINS = {
  live: 'https://tracklify.com',
  dev: 'https://devtracklify.com',
  local: 'http://tracklify.localhost:8800',
};

const SSR_DEBUG_DOMAINS = {
  live: 'https://debug.tracklify.com',
  dev: 'https://debug.devtracklify.com',
  local: 'http://debug.tracklify.localhost:8800',
};

const MCP_DOMAINS = {
  live: 'https://node1.tracklify.com/mcp',
  dev: 'https://node1.devtracklify.com/mcp',
  local: 'http://localhost:3001/mcp',
};

// imgproxy behind wait0 (deploy/helm); locally there is none and images load straight from the bucket
const IMG_PROXY_URLS = {
  live: 'https://web.tracklify.com/img',
  dev: 'https://web.devtracklify.com/img',
  local: '',
};

export default {
  getSSRDomain: () => {
    const source = document.location.hostname.split('.')[0].startsWith('debug') ? SSR_DEBUG_DOMAINS : SSR_DOMAINS;
    return source[process.env.VUE_APP_ENV];
  },
  getSPADomain: () => {
    const source = document.location.hostname.split('.')[0].startsWith('debug') ? SPA_DEBUG_DOMAINS : SPA_DOMAINS;
    return source[process.env.VUE_APP_ENV];
  },
  getMcpUrl: () => MCP_DOMAINS[process.env.VUE_APP_ENV],
  getImgProxyUrl: () => IMG_PROXY_URLS[process.env.VUE_APP_ENV],
  // SSR_DOMAIN: SSR_DOMAINS[process.env.VUE_APP_ENV],
  // SPA_DOMAIN: SPA_DOMAINS[process.env.VUE_APP_ENV],
  // SSR_DEBUG_DOMAIN: SSR_DEBUG_DOMAINS[process.env.VUE_APP_ENV],
  // SPA_DEBUG_DOMAIN: SPA_DEBUG_DOMAINS[process.env.VUE_APP_ENV],
};
